import './search/page-search.js';
export default {
  id: '358fabf75e',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page page-search" data-name="about">\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner">\n        <div class="left">\n          <a href="#" class="link back">\n            <i class="icon icon-back"></i>\n            <span class="if-not-md">Back</span>\n          </a>\n        </div>\n        <div class="title"></div>\n      </div>\n    </div>\n\n    <div class="page-content">\n      <page-search></page-search>      \n    </div>\n  </div>\n';
      return r;
    }(this);
  },

  style: `  
.page.page-search > .navbar {
  height: 10vh;
}

.navbar .navbar-bg,
[data-name="search"] .toolbar {
  background-color: transparent;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}

.page-search .navbar .navbar-inner,
.page-search .navbar .link {
  color: #ffffff;
}

.page-search .navbar .navbar-bg::after,
.page-search .navbar .navbar-bg::before {
  display: none;
}

.page-search .page-content {
  width: 100vw;
  height: 100vh;
  overflow: hidden;    
  padding: 0;
}

.link.back .if-not-md {
  display: none;
}

.icon-back::after {
  content: '' !important;
  display: inline-block;
  position: absolute;
  background-image: url('data:image/svg+xml,<svg width="50" height="20" version="1.1" id="레이어_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 132 132" style="enable-background:new 0 0 132 132;" xml:space="preserve"><g id="Path_1358"><polygon points="118.6,76.8 13.4,76.8 35,55.2 36.8,57.1 19.7,74.2 118.6,74.2 "/></g></svg>');
  width: 100px;
  height: 40px;
  top: -8px;
  left: -30px;
  background-size: contain;
  background-repeat: no-repeat;
}
`,
  styleScoped: false
};